// extracted by mini-css-extract-plugin
export var addViewLink = "_1c-1";
export var availabilityIcon = "_1c-16";
export var availabilitySelectionIcon = "_1c-15";
export var backButton = "_1c-2";
export var backIcon = "_1c-z";
export var conversationCount = "_1c-3";
export var dragHandle = "_1c-5";
export var dropdown = "_1c-e";
export var dropdownIcon = "_1c-7";
export var dropdownOption = "_1c-6";
export var dropdownTriangle = "_1c-d";
export var expand = "_1c-f";
export var folder = "_1c-i";
export var folderItem = "_1c-c";
export var icon = "_1c-8";
export var iconRow = "_1c-9";
export var image = "_1c-a";
export var logo = "_1c-b";
export var navContainer = "_1c-h";
export var navigationFooter = "_1c-g";
export var pageShell = "_1c-0";
export var placeholderAvailable = "_1c-11";
export var placeholderBox = "_1c-14";
export var placeholderBusy = "_1c-13";
export var placeholderUnavailable = "_1c-12";
export var profile = "_1c-k";
export var profileContainer = "_1c-m";
export var profileDropdown = "_1c-n";
export var profileImage = "_1c-l";
export var profileMain = "_1c-o";
export var profileSubtitle = "_1c-q";
export var profileTitle = "_1c-p";
export var reorderIcon = "_1c-r";
export var sentLine = "_1c-u";
export var settingsHeader = "_1c-s";
export var sidenavTextColor = "_1c-y";
export var spamLine = "_1c-t";
export var subitemWithTag = "_1c-4";
export var supportItems = "_1c-j";
export var teamText = "_1c-10";
export var viewLine = "_1c-x";
export var viewLineButton = "_1c-w";
export var viewLineButtons = "_1c-v";